import React from 'react';

import { DevTrack, TrackCode } from '../types';

type Counts = Record<TrackCode, { unlocked: number; total: number }>;

type Props = {
  tracks: DevTrack[];
  counts: Counts;
  focusTrack: TrackCode | null;
  onFocus: (code: TrackCode | null) => void;
  /** Transient hover preview: fires the hovered track code on enter, null on
   *  leave. Optional so existing callers keep working. */
  onHover?: (code: TrackCode | null) => void;
};

/** Floating legend; clicking a track focuses it (durable), hovering previews
 *  the same isolation while the cursor is on it. */
const TrackLegend: React.FC<Props> = ({
  tracks,
  counts,
  focusTrack,
  onFocus,
  onHover,
}) => (
  <div className="devplan-legend">
    <div className="devplan-legend__title">Tracks</div>
    {tracks.map((track) => {
      const c = counts[track.code];
      const active = focusTrack === track.code;
      return (
        <button
          type="button"
          key={track.code}
          className={`devplan-legend__item${active ? ' is-active' : ''}`}
          style={{ ['--track-color' as string]: track.color }}
          onMouseEnter={() => onHover?.(track.code)}
          onMouseLeave={() => onHover?.(null)}
          onClick={() => onFocus(active ? null : track.code)}
        >
          <span className="devplan-legend__dot" />
          <span className="devplan-legend__name">{track.name}</span>
          <span className="devplan-legend__count">
            {c.unlocked}/{c.total}
          </span>
        </button>
      );
    })}
    {focusTrack && (
      <button
        type="button"
        className="devplan-legend__clear"
        onClick={() => onFocus(null)}
      >
        Show all
      </button>
    )}
  </div>
);

export default TrackLegend;
